import React, { useState, useEffect } from "react";
import ChartDataLabels from "chartjs-plugin-datalabels";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  BarElement,
} from "chart.js";
import { Line, Bar } from "react-chartjs-2";
import Graph from "../util/graph";
import HotelChooser from "../components/HotelChooser";
import { Stack } from "@mui/material";
import HotelSwitch from "../components/HotelSwitch";
import AccountDataFinder from "./AccountDataFinder";
import labelFinder from "../util/labelFinder";
import HotelGroupSwitchContent from "../components/HotelGroupSwitchContent";
import moment from "moment";
import accountGraphProcessor from "./accountGraphProcessor";
import partnerFinder from "./partnerFinder";

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  BarElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  ChartDataLabels
);

const AccountGraph = ({
  analytics,
  title,
  allOptions,
  isTablularData,
  onToggleTabularData,
  isBar,
  isHotel,
  isDate,
  isPercentage,
  onToggleBar,
  onToggleHotel,
  onToggleDate,
  onTogglePercentage,
}) => {
  const [sHotels, setSHotels] = useState([]);
  const hotels = Object.keys(analytics);
  let allDates = Object.keys(analytics[hotels[0]]);
  const [options, setOptions] = useState(allOptions);
  const AllPartners = partnerFinder(analytics, "partners");
  const AllSources = partnerFinder(analytics, "sources");
  const [partner, setPartner] = useState([
    AllPartners.length > 0 ? AllPartners[0] : "Default",
  ]);
  const [source, setSource] = useState([
    AllSources.length > 0 ? AllSources[0] : "Default",
  ]);

  const [data, setData] = useState({});

  useEffect(() => {
    const hotels = Object.keys(analytics);
    let allDates = Object.keys(analytics[hotels[0]]);

    let datasets = AccountDataFinder(
      analytics,
      allDates,
      isHotel,
      isDate,
      allOptions,
      sHotels,
      options,
      isBar,
      isTablularData,
      partner,
      source
    );
    let labels = labelFinder(
      allDates.map((dt) => moment(dt, "DD-MM-YYYY").format("DD-MMM")),
      isHotel,
      isDate,
      sHotels
    );
    datasets = accountGraphProcessor(isPercentage, datasets, labels.length);
    setData({ labels, datasets });
  }, [
    analytics,
    options,
    isHotel,
    isDate,
    sHotels,
    isTablularData,
    isBar,
    allOptions,
    isPercentage,
    partner,
    source,
  ]);

  useEffect(() => {
    setSHotels(Object.keys(analytics));
    setOptions(allOptions);
  }, [analytics, allOptions]);

  return (
    <div style={{ margin: "20px", paddingTop: "20px", position: "relative" }}>
      <Stack
        style={{
          position: "absolute",
          top: "-10px",
          right: "10px",
        }}
        direction="row"
        spacing={1}
      >
        <HotelGroupSwitchContent
          content={
            <>
              <HotelSwitch
                isChecked={!isTablularData}
                label={"Data"}
                onChange={(v) => {
                  onToggleTabularData();
                }}
              />

              <HotelSwitch
                isChecked={isBar}
                label={"Bar"}
                onChange={(v) => {
                  onToggleBar();
                }}
              />

              {hotels.length > 1 ? (
                <HotelSwitch
                  isChecked={isHotel}
                  label={"Hotel"}
                  onChange={(v) => {
                    onToggleHotel();
                  }}
                />
              ) : (
                <></>
              )}

              {allDates.length > 1 ? (
                <HotelSwitch
                  isChecked={isDate}
                  label={"Date"}
                  onChange={(v) => {
                    onToggleDate();
                  }}
                />
              ) : (
                <></>
              )}

              <HotelSwitch
                isChecked={isPercentage}
                label={"Per(%)"}
                onChange={(v) => {
                  onTogglePercentage();
                }}
              />
            </>
          }
        />

        <HotelChooser
          hotels={allOptions}
          selectedHotels={options}
          onHotelsChange={(o) => {
            setOptions(o);
          }}
          width="80px"
        />

        {AllSources.length > 0 && (
          <HotelChooser
            hotels={AllSources}
            selectedHotels={source}
            onHotelsChange={(s) => {
              setSource(s);
            }}
            width="100px"
            label={"Source"}
          />
        )}

        {AllPartners.length > 0 && (
          <HotelChooser
            hotels={AllPartners}
            selectedHotels={partner}
            onHotelsChange={(s) => {
              setPartner(s);
            }}
            width="100px"
            label={"Partner"}
          />
        )}

        {hotels.length > 0 && (
          <HotelChooser
            hotels={hotels}
            selectedHotels={sHotels}
            onHotelsChange={(s) => {
              setSHotels(s);
            }}
            width="100px"
            label={"Hotels"}
          />
        )}
      </Stack>

      {data &&
        data.datasets &&
        data.datasets.length > 0 &&
        (isBar ? (
          <Bar
            style={{ marginTop: "20px" }}
            options={Graph.BarOptions(
              title,
              true,
              data.datasets.reduce((acc, cur) => {
                if (!acc[cur.stack]) {
                  let nAcc = { ...acc };
                  nAcc[cur.stack] = [cur];
                  return nAcc;
                } else {
                  let nAcc = { ...acc };
                  nAcc[cur.stack] = [...nAcc[cur.stack], cur];
                  return nAcc;
                }
              }, {})
            )}
            data={data}
          />
        ) : (
          <Line
            style={{ marginTop: "20px" }}
            options={Graph.Options(title)}
            data={data}
          />
        ))}
    </div>
  );
};

export default AccountGraph;
